import React, { useEffect } from "react"
import { useDialogControl } from "@/components/Dialog"

import { useDialogStore } from "@/store/dialog"

export const DialogTrigger: React.FC = () => {
    const { dialog, endDialog } = useDialogStore()
    const { startDialogue } = useDialogControl()

    useEffect(() => {
        if (dialog && dialog.length > 0) {
            startDialogue(dialog, endDialog)
        }
    }, [dialog])

    return null
}
